export default __webpack_public_path__ + "static/media/location.5cd6776e.svg";